import Keycloak from 'keycloak-js';
import { KeycloakConfigType, TokenDataType } from './authtypes';

export const exchangeCodeForTokens = async (
    authorizationCode: string,
    codeVerifier: string,
    keycloakConfigs: KeycloakConfigType,
) => {
    const tokenEndpoint = `${keycloakConfigs.url}/realms/${keycloakConfigs.realm}/protocol/openid-connect/token`;

    const params = new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: keycloakConfigs.clientId,
        code: authorizationCode,
        redirect_uri: 'flowdesktop://authservice-callback',
        code_verifier: codeVerifier,
        scope: 'openid',
    });

    const response = await fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
    });

    if (!response.ok) {
        throw new Error(
            `Token exchange failed: ${response.status} ${response.statusText}`,
        );
    }

    const tokenData = await response.json();
    return tokenData as TokenDataType;
};

export const electronAppAuthLogout = async (keycloakInstance: Keycloak) => {
    const { authServerUrl, realm, clientId, refreshToken } = keycloakInstance;
    const logoutEndpoint = `${authServerUrl}/realms/${realm}/protocol/openid-connect/logout`;

    const params = new URLSearchParams({
        client_id: clientId,
        refresh_token: refreshToken,
    });

    const response = await fetch(logoutEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
    });

    if (response.ok) {
        sessionStorage.removeItem('pkce_code_verifier');
    } else {
        console.error('Logout failed', await response.text());
    }
};
